export default "__VITE_ASSET__BsndSb2I__"